const { values } = require('underscore');

define(function (require) {
	const tpl = require('./templates/t_itv_radio_button_field.hbs');
	const baseElement = require('./v_itv_base_element');
	const DetailUtils = require('../detail_utilities');
	return baseElement.extend({
		template:tpl,
		templateHelpers:function(){
			//get baseElement Template Helpers
			var baseTH = baseElement.prototype.templateHelpers.apply(this);
			
			return $.extend({},baseTH,{
				classes:'radio-button-field' + 
					(this.model.get('isVisible') === false ? ' hidden':'') +
					(this.model.get('fullWidthField') === true ? ' full-width' : ''),
				labelClasses:'radio-label',
				radioClasses:this.model.get('horizontalAlign') === true ? 'radio-button horizontal-align':'radio-button',
				//if this is an HTML radio button, the required asterisk 
				//needs to be included in the HTML for proper placement. use <em class="required">*</em>
				isRequiredLabel:this.model.get('isHtml') === true ? false : this.model.get('isRequired'),
				//can't properly place a tooltip if the field has HTML in the label, so we won't.
				tooltip:this.model.get('isHtml') === false ? this.model.get('tooltip') : '',
				valueSelections:()=>{
					let valueSelections = [];
					if(this.model.get('valueSelections') && this.model.get('valueSelections') instanceof Backbone.Collection){
						this.model.get('valueSelections').each((value)=>{
							//we need a unique ID for each option.
							let val = value.toJSON();
							val.id = this.model.get('id')+DetailUtils.generateId();
							val.name = this.model.get('id');
							valueSelections.push(val);
						});
					}
					return valueSelections;
				}
			});

		},
		getValue: function () {
			if (this.model.get('isEnabled') === false || this.config.readOnlyForm) {
				return this.model.get('value');
			} 
			return  $('input[name="'+this.model.get('id')+'"]:checked').val();
		},
	});
});
